/**
 * @generated SignedSource<<a6f4d3b7b6e4938ae4781ff6564e82af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useJsonLogicGetIngestionConfigByPropertyBatchQuery$variables = {
  properyBatchId?: number | null;
};
export type useJsonLogicGetIngestionConfigByPropertyBatchQuery$data = {
  readonly sys_property_batches: ReadonlyArray<{
    readonly submission: {
      readonly provider: {
        readonly ingestion_config: any | null;
        readonly provider_id: number;
        readonly provider_name: string;
      };
    };
  }>;
};
export type useJsonLogicGetIngestionConfigByPropertyBatchQuery = {
  response: useJsonLogicGetIngestionConfigByPropertyBatchQuery$data;
  variables: useJsonLogicGetIngestionConfigByPropertyBatchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "properyBatchId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "properyBatchId"
              }
            ],
            "kind": "ObjectValue",
            "name": "property_batch_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_property_batches",
    "kind": "LinkedField",
    "name": "sys_property_batches",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_submissions",
        "kind": "LinkedField",
        "name": "submission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "sys_providers",
            "kind": "LinkedField",
            "name": "provider",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "provider_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "provider_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ingestion_config",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useJsonLogicGetIngestionConfigByPropertyBatchQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useJsonLogicGetIngestionConfigByPropertyBatchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c2aa4037dd033af39bf1842d8f70a86d",
    "id": null,
    "metadata": {},
    "name": "useJsonLogicGetIngestionConfigByPropertyBatchQuery",
    "operationKind": "query",
    "text": "query useJsonLogicGetIngestionConfigByPropertyBatchQuery(\n  $properyBatchId: Int\n) {\n  sys_property_batches(where: {property_batch_id: {_eq: $properyBatchId}}) {\n    submission {\n      provider {\n        provider_id\n        provider_name\n        ingestion_config\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d0f9211e95d1353d608f0b0d4ea611d";

export default node;
